var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useThdCustomer } from '@thd-olt-functional/customer-information';
import React, { createContext, useState } from 'react';
import { getCPSItemLevelSearch } from '../api/oms/order-history';
import { makeSearchRequestBody } from '../components/purchase-history/util/searchResultsUtils';
import { useCommonContext, useExperienceContext, usePurchaseHistoryContext, } from '../hooks/useContexts';
import { getWindow } from '../utils/general';
var defaultState = {
    fetchMoreResults: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, Promise.resolve()];
    }); }); },
    isMobile: false,
    loading: { moreResults: false, initialResults: false },
    searchItems: [],
    searchPageNumber: 1,
    setLoading: function () { return null; },
    setSearchItems: function () { return null; },
    setSearchPageNumber: function () { return null; },
};
export var SearchResultsContext = createContext(defaultState);
export var SearchResultsProvider = function (_a) {
    var _b;
    var children = _a.children;
    var thdCustomerInfo = useThdCustomer();
    var isMobile = useCommonContext().isMobile;
    var orderHistoryData = usePurchaseHistoryContext().orderHistoryData;
    var channel = useExperienceContext().channel;
    var _c = useState([]), searchItems = _c[0], setSearchItems = _c[1];
    var _d = useState(1), searchPageNumber = _d[0], setSearchPageNumber = _d[1];
    var _e = useState({
        moreResults: false,
        initialResults: false,
    }), loading = _e[0], setLoading = _e[1];
    var orderHistoryInfo = JSON.parse(((_b = getWindow()) === null || _b === void 0 ? void 0 : _b.sessionStorage.getItem('orderHistoryInfo')) || '{}');
    var fetchMoreResults = function (searchItem) { return __awaiter(void 0, void 0, void 0, function () {
        var request, response_1, status_1, error_1, status_2;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setLoading(function (prevState) { return (__assign(__assign({}, prevState), { moreResults: true })); });
                    request = makeSearchRequestBody(searchItem, thdCustomerInfo, orderHistoryData, orderHistoryInfo, searchPageNumber, searchItems);
                    return [4 /*yield*/, getCPSItemLevelSearch(request, channel)];
                case 1:
                    response_1 = _b.sent();
                    status_1 = response_1 ? response_1.status : null;
                    if (status_1 === null) {
                        return [2 /*return*/];
                    }
                    setSearchItems(function (prevState) { return (__assign(__assign({}, response_1.data), { lineItems: __spreadArray(__spreadArray([], ((prevState === null || prevState === void 0 ? void 0 : prevState.lineItems) || []), true), response_1.data.lineItems, true) })); });
                    setSearchPageNumber(function (prevPageNumber) { return prevPageNumber + 1; });
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _b.sent();
                    if (typeof error_1 === 'object' &&
                        error_1 !== null &&
                        'response' in error_1 &&
                        typeof error_1.response ===
                            'object') {
                        status_2 = (_a = error_1.response) === null || _a === void 0 ? void 0 : _a.status;
                    }
                    return [3 /*break*/, 4];
                case 3:
                    setLoading(function (prevState) { return (__assign(__assign({}, prevState), { moreResults: false })); });
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(SearchResultsContext.Provider, { value: {
            fetchMoreResults: fetchMoreResults,
            isMobile: isMobile,
            searchItems: searchItems,
            searchPageNumber: searchPageNumber,
            setSearchItems: setSearchItems,
            setSearchPageNumber: setSearchPageNumber,
            loading: loading,
            setLoading: setLoading,
        } }, children));
};
